/** 첫 기록 직후 칩으로 고르는 질환 묶음(6개). 나머지 태그는 아이 정보에서만 고른다. */
export const FIRST_RECORD_CONDITION_CHIPS = ['heart', 'kidney', 'diabetes', 'joint', 'seizure', 'respiratory'];
const SUGGESTIONS = {
    heart: ['srr', 'cough', 'weight', 'treatment'],
    kidney: ['water', 'urine', 'weight', 'treatment'],
    diabetes: ['glucose', 'meal', 'treatment'],
    liver: ['meal', 'weight', 'event'],
    joint: ['gait', 'weight'],
    cognitive: ['qol', 'checkin', 'event'],
    seizure: ['seizure', 'treatment'],
    respiratory: ['srr', 'cough', 'event'],
    endocrine: ['weight', 'meal', 'treatment'],
    tumor: ['event', 'weight', 'qol'],
    dental: ['meal', 'event'],
    gi: ['meal', 'event', 'weight'],
    skin: ['event'],
    other: ['checkin', 'event'],
};
/** Return stable, de-duplicated suggestions. Tags never force a record. */
export function suggestionsForConditions(tags) {
    const seen = new Set();
    for (const tag of tags)
        for (const suggestion of SUGGESTIONS[tag] ?? [])
            seen.add(suggestion);
    return [...seen];
}
